
import { Headset } from "lucide-react";

const HeroSection = () => {
  return (
    <section className="bg-[#072c39] py-16 md:py-24 text-white relative overflow-hidden">
      <div className="absolute top-0 right-0 w-48 sm:w-72 h-48 sm:h-72 bg-drcash-caribbean-green/10 rounded-full blur-2xl"></div>
      <div className="absolute bottom-0 left-0 w-64 sm:w-96 h-64 sm:h-96 bg-drcash-tiffany-blue/10 rounded-full blur-2xl"></div>
      
      <div className="container mx-auto px-4 relative z-10 text-center">
        <div className="mx-auto mb-6">
          <Headset className="w-16 h-16 mx-auto text-drcash-caribbean-green" />
        </div>
        <h1 className="text-4xl md:text-5xl font-bold mb-6">
          Central de Atendimento
        </h1>
        <p className="text-drcash-cadet-gray max-w-2xl mx-auto text-lg">
          Estamos aqui para ajudar você. Nossa equipe está pronta para responder suas dúvidas 
          e oferecer o suporte necessário para o seu negócio.
        </p>
      </div>
    </section>
  );
};

export default HeroSection;
